"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useRef, createContext, useContext, type ReactNode } from "react";
import { WebsocketProvider } from "y-websocket";
import type { Provider } from "@lexical/yjs";
import * as Y from "yjs";
interface CollabContextValue {
  providerFactory: (id: string, yjsDocMap: Map<string, Y.Doc>) => Provider;
  setWsToken: (entryId: string, token: string) => void;
  getProvider: (entryId: string) => WebsocketProvider | null;
  getAwareness: (entryId: string) => WebsocketProvider["awareness"] | null;
}
const CollabContext = createContext<CollabContextValue | null>(null);
export function CollaborationProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = new Map();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const tokenMapRef = useRef(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = new Map();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const providerMapRef = useRef(t2);
  const wsProtocol = typeof window !== "undefined" && window.location.protocol === "https:" ? "wss:" : "ws:";
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    const wsHost = typeof window !== "undefined" ? window.location.hostname.replace(/^www\./, "").startsWith("localhost") ? "localhost:8787" : `worker.${window.location.hostname.replace(/^www\./, "")}` : "localhost:8787";
    const baseUrl = `${wsProtocol}//${wsHost}/ws/collab`;
    t3 = {
      providerFactory: (id, yjsDocMap) => {
        const cached = providerMapRef.current.get(id);
        if (cached) {
          return cached as unknown as Provider;
        }
        let doc = yjsDocMap.get(id);
        if (!doc) {
          doc = new Y.Doc();
          yjsDocMap.set(id, doc);
        } else {
          doc.load();
        }
        const token = tokenMapRef.current.get(id);
        const params = {};
        if (token) {
          params.token = token;
        }
        const provider = new WebsocketProvider(baseUrl, id, doc, {
          connect: false,
          params
        });
        providerMapRef.current.set(id, provider);
        return provider as unknown as Provider;
      },
      setWsToken: (entryId, token_0) => {
        tokenMapRef.current.set(entryId, token_0);
      },
      getProvider: entryId_0 => providerMapRef.current.get(entryId_0) ?? null,
      getAwareness: entryId_1 => providerMapRef.current.get(entryId_1)?.awareness ?? null
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const value = t3;
  let t4;
  if ($[3] !== children) {
    t4 = <CollabContext.Provider value={value}>{children}</CollabContext.Provider>;
    $[3] = children;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export function useCollaborationProvider() {
  const ctx = useContext(CollabContext);
  if (!ctx) {
    throw new Error("useCollaborationProvider must be used within a CollaborationProvider");
  }
  return ctx;
}